module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-router-dom/~/isarray/index.js
 ** module id = 1899
 ** module chunks = 0
 **/